import React, { useState } from "react";
import { useSettings, useCart } from "../lib/providers";
import { firePixelEvent } from "./TrackingScripts";

function WAIcon() {
  return (
    <svg viewBox="0 0 32 32" className="w-7 h-7" fill="currentColor">
      <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.044 2.264v.114c-.015.99.472 1.977 1.13 2.78 1.303 1.748 2.986 3.294 5 4.123.9.413 2.342.935 3.33.958h.03c.466 0 1.087-.102 1.56-.273.485-.203.971-.83 1.1-1.332.115-.422.185-.867.185-1.28 0-.173-.043-.332-.144-.459-.33-.414-2.047-1.24-2.532-1.243z"/>
      <path d="M16.03 0C7.205 0 .02 7.157.02 15.945a15.88 15.88 0 0 0 2.144 7.98L0 32l8.31-2.177a15.966 15.966 0 0 0 7.72 1.968h.002c8.824 0 16.01-7.157 16.01-15.945C32.04 7.157 24.855 0 16.03 0zm0 29.205h-.002a13.239 13.239 0 0 1-6.742-1.836l-.484-.287-5.016 1.314 1.34-4.883-.315-.502a13.108 13.108 0 0 1-2.015-7.066c0-7.267 5.944-13.18 13.242-13.18 3.538 0 6.861 1.372 9.362 3.863a13.103 13.103 0 0 1 3.875 9.318c-.002 7.266-5.945 13.18-13.245 13.18z"/>
    </svg>
  );
}

export default function WhatsAppFloater() {
  const { settings } = useSettings();
  const { count } = useCart();
  const [open, setOpen] = useState(false);
  const fr = (settings.whatsapp_fr || "").replace(/\D/g, "");
  const dz = (settings.whatsapp_dz || "").replace(/\D/g, "");
  const links = [
    { id: "dz", href: `https://wa.me/${dz}`, label: "Algérie", bg: "bg-[#25D366]" },
    { id: "fr", href: `https://wa.me/${fr}`, label: "France", bg: "bg-[#128C7E]" },
  ];

  return (
    <div className={`fixed ${count > 0 ? "bottom-24" : "bottom-5"} end-3.5 z-50 flex flex-col items-end gap-2`} data-testid="whatsapp-floater">
      {open && links.map((l) => (
        <a
          key={l.id}
          href={l.href}
          onClick={() => { firePixelEvent("Contact", { source: "floater", channel: `whatsapp_${l.id}` }); setOpen(false); }}
          target="_blank"
          rel="noreferrer"
          className={`flex items-center gap-2 min-h-[44px] px-4 text-white text-xs font-black uppercase tracking-widest shadow-lg ${l.bg}`}
          data-testid={`whatsapp-${l.id}`}
        >
          {l.label}
        </a>
      ))}
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label="WhatsApp"
        aria-expanded={open}
        className="w-[52px] h-[52px] rounded-full bg-[#25D366] text-white grid place-items-center shadow-lg shadow-[#25D366]/30"
        data-testid="whatsapp-toggle"
      >
        <WAIcon />
      </button>
    </div>
  );
}
